import { render, staticRenderFns } from "./ZCJFTempalte.vue?vue&type=template&id=477aa078"
import script from "./ZCJFTempalte.vue?vue&type=script&lang=js"
export * from "./ZCJFTempalte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports